/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AdminOrganisationDetailDto } from '../model/adminOrganisationDetailDto';
import { AdminOrganisationRequestDto } from '../model/adminOrganisationRequestDto';
import { AdminPagedResponseDto } from '../model/adminPagedResponseDto';
import { AdminPagedResponseDtoAdminOrganisationDetailDto } from '../model/adminPagedResponseDtoAdminOrganisationDetailDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AdminOrganisationManagementService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Organisation anlegen
     * Legt Organisation samt Kontingent an und macht ownerUserId zum ORGANISATION_ADMIN
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOrganisation1(body?: AdminOrganisationRequestDto, observe?: 'body', reportProgress?: boolean): Observable<AdminOrganisationDetailDto>;
    public createOrganisation1(body?: AdminOrganisationRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminOrganisationDetailDto>>;
    public createOrganisation1(body?: AdminOrganisationRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminOrganisationDetailDto>>;
    public createOrganisation1(body?: AdminOrganisationRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AdminOrganisationDetailDto>('post',`${this.basePath}/admin/organisations`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Organisation löschen
     * Löscht eine Organisation (Soft-Delete, setzt deletedAt-Zeitstempel)
     * @param organisationId Organisations-ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOrganisation1(organisationId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteOrganisation1(organisationId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteOrganisation1(organisationId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteOrganisation1(organisationId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (organisationId === null || organisationId === undefined) {
            throw new Error('Required parameter organisationId was null or undefined when calling deleteOrganisation1.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/admin/organisations/${encodeURIComponent(String(organisationId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Alle Organisationen abrufen
     * Gibt eine paginierte Liste aller Organisationen zurück
     * @param page Seitenzahl (0-indexed)
     * @param pageSize Anzahl der Einträge pro Seite
     * @param sortBy Sortierfeld (z.B. &#x27;name&#x27; oder &#x27;id&#x27;)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllOrganisations(page?: number, pageSize?: number, sortBy?: string, observe?: 'body', reportProgress?: boolean): Observable<AdminPagedResponseDto>;
    public getAllOrganisations(page?: number, pageSize?: number, sortBy?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminPagedResponseDto>>;
    public getAllOrganisations(page?: number, pageSize?: number, sortBy?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminPagedResponseDto>>;
    public getAllOrganisations(page?: number, pageSize?: number, sortBy?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('pageSize', <any>pageSize);
        }
        if (sortBy !== undefined && sortBy !== null) {
            queryParameters = queryParameters.set('sortBy', <any>sortBy);
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminPagedResponseDto>('get',`${this.basePath}/admin/organisations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Organisationsdetails abrufen
     * Gibt detaillierte Informationen zu einer spezifischen Organisation zurück
     * @param organisationId Organisations-ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrganisationById(organisationId: number, observe?: 'body', reportProgress?: boolean): Observable<AdminOrganisationDetailDto>;
    public getOrganisationById(organisationId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminOrganisationDetailDto>>;
    public getOrganisationById(organisationId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminOrganisationDetailDto>>;
    public getOrganisationById(organisationId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (organisationId === null || organisationId === undefined) {
            throw new Error('Required parameter organisationId was null or undefined when calling getOrganisationById.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminOrganisationDetailDto>('get',`${this.basePath}/admin/organisations/${encodeURIComponent(String(organisationId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Organisationen suchen
     * Sucht Organisationen nach Name, E-Mail oder Stadt
     * @param query Suchbegriff
     * @param page Seitenzahl (0-indexed)
     * @param pageSize Anzahl der Einträge pro Seite
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchOrganisations(query: string, page?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<AdminPagedResponseDtoAdminOrganisationDetailDto>;
    public searchOrganisations(query: string, page?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminPagedResponseDtoAdminOrganisationDetailDto>>;
    public searchOrganisations(query: string, page?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminPagedResponseDtoAdminOrganisationDetailDto>>;
    public searchOrganisations(query: string, page?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (query === null || query === undefined) {
            throw new Error('Required parameter query was null or undefined when calling searchOrganisations.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', <any>query);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('pageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminPagedResponseDtoAdminOrganisationDetailDto>('get',`${this.basePath}/admin/organisations/search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Organisation aendern
     * Stammdaten und Adresse. Fehlendes Feld bleibt unveraendert.
     * @param organisationId Organisation ID
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateOrganisation1(organisationId: number, body?: AdminOrganisationRequestDto, observe?: 'body', reportProgress?: boolean): Observable<AdminOrganisationDetailDto>;
    public updateOrganisation1(organisationId: number, body?: AdminOrganisationRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminOrganisationDetailDto>>;
    public updateOrganisation1(organisationId: number, body?: AdminOrganisationRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminOrganisationDetailDto>>;
    public updateOrganisation1(organisationId: number, body?: AdminOrganisationRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (organisationId === null || organisationId === undefined) {
            throw new Error('Required parameter organisationId was null or undefined when calling updateOrganisation1.');
        }


        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AdminOrganisationDetailDto>('put',`${this.basePath}/admin/organisations/${encodeURIComponent(String(organisationId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
